import React from 'react';
import Loading from 'components/Loading';

import './styles.css';

const MyTeamsSection = ({teams, isLoading}) => (
  <div className="MyTeamsSection">
    <div className="heading">My Teams</div>
    {isLoading && <Loading />}
    {!isLoading && <div className="content">{teams}</div>}
  </div>
);

export default MyTeamsSection;
